<template>
    <div class="stock_record_detail">
        <!-- 头部 -->
        <div class="detail_header">
            <div class="back_btn" @click="$router.back()">
                <van-icon name="arrow-left" size="24" />
            </div>
            <span class="header_title">记录详情</span>
            <div class="placeholder"></div>
        </div>

        <!-- 详情内容 -->
        <div class="detail_content" v-if="detail.id">
            <div class="detail_section">
                <div class="detail_row">
                    <span class="label">类型</span>
                    <van-tag :type="detail.apply_type === 'product' ? 'primary' : 'success'">
                        {{detail.apply_type === 'product' ? '产品' : '物料'}}
                    </van-tag>
                </div>
                <div class="detail_row">
                    <span class="label">名称</span>
                    <span class="value">{{detail.record_name || '-'}}</span>
                </div>
                <div class="detail_row">
                    <span class="label">操作</span>
                    <span class="value" :class="detail.in_out">
                        {{detail.in_out === 'in' ? '入库' : '出库'}} {{detail.apply_num}}件
                    </span>
                </div>
                <div class="detail_row">
                    <span class="label">状态</span>
                    <span class="value status" :class="detail.sure_user_id ? 'status_1' : 'status_0'">
                        {{detail.sure_user_id ? '已确认' : '待确认'}}
                    </span>
                </div>
                <div class="detail_row">
                    <span class="label">申请人</span>
                    <span class="value">{{detail.apply_user_name || '-'}}</span>
                </div>
                <div class="detail_row">
                    <span class="label">申请时间</span>
                    <span class="value">{{detail.create_time | formatTime}}</span>
                </div>
                <div class="detail_row" v-if="detail.remark">
                    <span class="label">备注</span>
                    <span class="value">{{detail.remark}}</span>
                </div>
            </div>
            
            <!-- 确认按钮 -->
            <div class="action_section" v-if="!detail.sure_user_id && canConfirm()">
                <van-button type="primary" block round @click="confirmStock">
                    确认
                </van-button>
            </div>
        </div>

        <!-- 加载中 -->
        <div class="loading_state" v-else>
            <van-loading type="spinner" size="40px" />
            <span>加载中...</span>
        </div>
    </div>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import studio_tool_api from '@/api/teaching_studio_tool.js'
import until from '@/api/until.js'
import { formatIotmaxTimestamp, getIotmaxFormAuth, hasIotmaxStockRole } from '@/utils/iotmaxStock.js'

export default {
    name: 'StockRecordDetail',
    data() {
        return {
            detail: {}
        }
    },
    filters: {
        formatTime(timestamp) {
            return formatIotmaxTimestamp(timestamp)
        }
    },
    mounted() {
        document.title = "记录详情"
        this.getDetail()
    },
    methods: {
        // 获取详情
        async getDetail() {
            const id = this.$route.query.id
            if (!id) {
                this.$toast('缺少ID参数')
                return
            }

            this.$toast.loading({ message: '加载中...' })
            
            try {
                let res = await studio_api.Teaching_studio_apiIotmaxStock_out_applyDetailGet({
                    app_id: this.$root.app_id,
                    id: id
                })
                if (res.errcode == 0 && res.other) {
                    this.detail = res.other
                } else {
                    this.$toast('获取详情失败')
                }
            } catch (e) {
                console.error('获取详情失败', e)
                this.$toast('获取详情失败')
            } finally {
                this.$toast.clear()
            }
        },

        // 判断是否有确认权限
        canConfirm() {
            return hasIotmaxStockRole(this.$root.userInfo, 'handle', this.$root.isSuperRoot)
        },

        // 确认出入库
        async confirmStock() {
            // 显示确认对话框
            const inOutText = this.detail.in_out === 'in' ? '入库' : '出库'
            try {
                await this.$dialog.confirm({
                    title: '确认操作',
                    message: `确定要确认该${inOutText}记录吗？`,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
            } catch (e) {
                // 用户取消
                return
            }

            this.$toast.loading({ message: '确认中...', duration: 0 })

            try {
                const { computer_code, salt } = await getIotmaxFormAuth(studio_tool_api, until)

                let res = await studio_api.Teaching_studio_apiIotmaxStock_out_applySurePut({
                    app_id: this.$root.app_id,
                    computer_code,
                    salt,
                    id: this.detail.id
                })

                this.$toast.clear()

                if (res.errcode === 0) {
                    this.$toast.success('确认成功')
                    // 重新获取详情
                    this.getDetail()
                } else {
                    this.$toast(res.errmsg || '确认失败')
                }
            } catch (e) {
                this.$toast.clear()
                console.error('确认失败', e)
                this.$toast('确认失败')
            }
        }
    }
}
</script>

<style scoped>
.stock_record_detail {
    width: 100%;
    min-height: 100vh;
    background: #F6F6F6;
}

.detail_header {
    width: 100%;
    height: 88px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    position: sticky;
    top: 0;
    z-index: 100;
}

.back_btn i {
    font-size: 40px;
    color: #333;
}

.header_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.placeholder {
    width: 40px;
}

.detail_content {
    padding: 20px;
    background: #F6F6F6;
    min-height: calc(100vh - 88px);
}

.detail_section {
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.detail_row {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #f5f5f5;
}

.detail_row:last-child {
    border-bottom: none;
}

.detail_row .label {
    width: 140px;
    font-size: 26px;
    color: #999;
    flex-shrink: 0;
}

.detail_row .value {
    flex: 1;
    font-size: 26px;
    color: #333;
    word-break: break-all;
    font-weight: 500;
}

.detail_row .value.in {
    color: #4CAF50;
}

.detail_row .value.out {
    color: #F44336;
}

.detail_row .value.status {
    font-weight: 600;
}

.detail_row .value.status.status_0 {
    color: #FF9800;
}

.detail_row .value.status.status_1 {
    color: #4CAF50;
}

.loading_state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 200px;
}

.loading_state span {
    margin-top: 20px;
    font-size: 26px;
    color: #999;
}

/* 操作区域 */
.action_section {
    padding: 20px;
    position: sticky;
    bottom: 20px;
}
</style>
